import awakingImg from '@/static/assets/customer_reviews/pics/tweet_face_awaking.png';
import brentImg from '@/static/assets/customer_reviews/pics/tweet_face_brent.png';
import jakobImg from '@/static/assets/customer_reviews/pics/tweet_face_jakob.png';
import jenniferImg from '@/static/assets/customer_reviews/pics/tweet_face_jennifer.png';
import mariaImg from '@/static/assets/customer_reviews/pics/tweet_face_maria.png';
import rashiqImg from '@/static/assets/customer_reviews/pics/tweet_face_rashiq.png';

export const tweets = [
  {
    name: 'Jakob Wahlers',
    handle: 'jakobwahlers',
    img: jakobImg,
    text: 'Big thumps-up to <span class="primary">@Lemonade_Inc</span> !  I haven’t purchased an insurance policy that simple, fair and transparent yet. <span class="primary">#insurance #digitisation #paperless</span>',
  },
  {
    name: 'Rashiq in SF',
    handle: 'rashiq',
    img: rashiqImg,
    text: '<span class="primary">@Lemonade_Inc</span> wow this was hands down the best insurance experience ever. holy shit I love your app.',
  },
  {
    name: 'Brent',
    img: brentImg,
    handle: 'goforbrent',
    text: '<span class="primary">@Lemonade_Inc</span> was the simplest and easiest insurance I’ve ever purchased, “old” insurance companies need to step into the current century!!! 👏 👏 👏',
  },
  {
    name: 'Jennifer Troyer',
    img: jenniferImg,
    handle: 'jennifer_troyer',
    text: 'I just learned about <span class="primary">@Lemonade_Inc</span> this morning and now they have a new customer. I swear it was one of the most enjoyable conversion and onboarding experiences I’ve had…maybe ever. I kind of want to do it all over again, Well done!',
  },
  {
    name: 'Maria Salamanka',
    handle: 'MariaSalamankaM',
    img: mariaImg,
    text: 'Always disappointed in how much insurance will fight against customer in a claim. Just had my first good experience with filing. Unbelievably quick and solid customer experience with <span class="primary">@Lemonade_Inc</span>.',
  },
  {
    name: 'AWaking Dream',
    handle: 'AWaking_Dream',
    img: awakingImg,
    text: 'Once every 2-3 years, I stumble across a truly outstanding app / business which nails everything. UX, pricing, customer service - <span class="primary">@Lemonade_Inc</span> has it all and I love it: <span class="primary">www.lemonade.com/de/en</span>',
  },
];
